import { render, staticRenderFns } from "./ProveedorOrdenCompra.vue?vue&type=template&id=5939d25b&scoped=true&"
import script from "./ProveedorOrdenCompra.vue?vue&type=script&lang=js&"
export * from "./ProveedorOrdenCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939d25b",
  null
  
)

export default component.exports